/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GlobalThresholdDTO } from "../models/GlobalThresholdDTO";
import type { ProjectDTO } from "../models/ProjectDTO";
import type { ProjectThresholdDTO } from "../models/ProjectThresholdDTO";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class MachineLearningSettingsService {
  /**
   * @returns GlobalThresholdDTO
   * @throws ApiError
   */
  public static machineLearningSettingsGetGlobalThreshold(): CancelablePromise<GlobalThresholdDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/MachineLearningSettings/GetGlobalThreshold",
    });
  }

  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static machineLearningSettingsUpdateGlobalThreshold(
    requestBody: GlobalThresholdDTO
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/MachineLearningSettings/UpdateGlobalThreshold",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns ProjectThresholdDTO
   * @throws ApiError
   */
  public static machineLearningSettingsGetProjectThresholds(): CancelablePromise<
    Array<ProjectThresholdDTO>
  > {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/MachineLearningSettings/GetProjectThresholds",
    });
  }

  /**
   * @param id
   * @param pageSize
   * @param sortColumn
   * @param sortOrder
   * @param searchValue
   * @param filterValue
   * @returns ProjectThresholdDTO
   * @throws ApiError
   */
  public static machineLearningSettingsGetProjectThresholdsPaged(
    id?: number | null,
    pageSize?: number | null,
    sortColumn?: string | null,
    sortOrder?: string | null,
    searchValue?: string | null,
    filterValue?: string | null
  ): CancelablePromise<Array<ProjectThresholdDTO>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/MachineLearningSettings/GetProjectThresholdsPaged",
      query: {
        id: id,
        pageSize: pageSize,
        sortColumn: sortColumn,
        sortOrder: sortOrder,
        searchValue: searchValue,
        filterValue: filterValue,
      },
    });
  }

  /**
   * @returns ProjectDTO
   * @throws ApiError
   */
  public static machineLearningSettingsGetProjectsForProjectThresholds(): CancelablePromise<
    Array<ProjectDTO>
  > {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/MachineLearningSettings/GetProjectsForProjectThresholds",
    });
  }

  /**
   * @param id
   * @param pageSize
   * @param searchValue
   * @returns ProjectDTO
   * @throws ApiError
   */
  public static machineLearningSettingsGetProjectsForProjectThresholdsPaged(
    id?: number | null,
    pageSize?: number | null,
    searchValue?: string | null
  ): CancelablePromise<Array<ProjectDTO>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/MachineLearningSettings/GetProjectsForProjectThresholdsPaged",
      query: {
        id: id,
        pageSize: pageSize,
        searchValue: searchValue,
      },
    });
  }

  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static machineLearningSettingsMergeProjectThreshold(
    requestBody: ProjectThresholdDTO
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/MachineLearningSettings/MergeProjectThreshold",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static machineLearningSettingsDeleteProjectThreshold(
    requestBody: ProjectThresholdDTO
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/MachineLearningSettings/DeleteProjectThreshold",
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
